import styled, { css } from 'styled-components'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { StyledThemedButton } from '../../ThemedButton/styles'
import { Box } from '../../UI/Box'
import { useShouldShowForThreshold } from '../../../theme'
import { ThemedButton } from '../../ThemedButton'

export const APPS = ['launch', 'drops', 'labs']
export type AppType = (typeof APPS)[number] | undefined

export function AppToggler({
  currentApp,
  setCurrentApp,
  asLinks = true,
  jc = false,
  hideImages = false,
  invertColors = false,
}: {
  currentApp?: AppType
  setCurrentApp?: (app: AppType) => void
  asLinks?: boolean
  jc?: boolean
  hideImages?: boolean
  invertColors?: boolean
}) {
  const isAtLeastMediumDisplaySize = useShouldShowForThreshold('medium')
  const location = useLocation()

  const getActiveApp = () => {
    if (asLinks) {
      const pathname = location.pathname.split('/')[1]
      return pathname === 'launch' ? 'launch' : pathname
    }
    return currentApp
  }

  const handleAppChange = (app) => {
    if (!asLinks && setCurrentApp) {
      setCurrentApp(app)
    }
  }

  const renderAppToggler = ({ app }) => {
    const isActive = getActiveApp() === app

    const shouldShowImages = !hideImages && isAtLeastMediumDisplaySize

    return (
      <AppToggleButton
        key={app}
        onClick={() => handleAppChange(app)}
        $styleType={isActive ? 'primary' : (invertColors ? 'tertiary-invert' : 'tertiary')}
        invertColors={invertColors}
        isActive={isActive}
        w="auto"
        pad={shouldShowImages ? 's' : 12}
        padH={16}
        padR={shouldShowImages ? 'm' : 16}
        bst={isActive ? 'filled' : 'alpha'}
      >
        <Box g={8} ac>
          {shouldShowImages && <img src={`/icon-${app}.svg`} alt={app} />}
          <img src={`/img/logos/app-logos/${app}.svg`} alt="ZAP Logo" />
        </Box>
      </AppToggleButton>
    )
  }

  const renderAppTogglerAsLink = ({ app }) => {
    return (
      <RouterLink to={`/${app === 'launch' ? 'launch' : app}`} key={app}>
        {renderAppToggler({ app })}
      </RouterLink>
    )
  }

  return (
    <Box g={8} jc={jc}>
      {APPS.map((app) =>
        asLinks ? renderAppTogglerAsLink({ app }) : renderAppToggler({ app }),
      )}
    </Box>
  )
}

export const AppToggleButton = styled(StyledThemedButton) <{
  isActive?: boolean
  invertColors?: boolean
}>`
  img {
    ${({ isActive, invertColors }) => (!isActive ? (invertColors ? 'filter: saturate(0) invert(1);' : 'filter: saturate(0);') : '')}
  }
`
